module.exports = __webpack_public_path__ + "static/media/subscribe-device@3x.fcf6fafc.png";